import PropTypes from 'prop-types'
import React from 'react'
import _ from 'lodash'
import getCardIcon from '../../utils/getCardIcon'
import './styles.css'

function PaymentMethodDetails({ creditCardPayment = null, paypalPayment = null }) {
  return (
    <div className="credit-card">
      {creditCardPayment && (
        <div className="payment-method-body">
          <div className="credit-card-icon">
            <img
              src={creditCardPayment.imageUrl ? creditCardPayment.imageUrl : getCardIcon(creditCardPayment.cardType)}
              alt="card"
            />
          </div>
          <div className="payment-method-description">
            <div className="card-description">
              {!_.isNull(creditCardPayment.cardType) && (
                <div className="card-type">{creditCardPayment.cardType}</div>
              )}
              {!_.isNull(creditCardPayment.last4) && (
                <div className="card-last-four">ending in {creditCardPayment.last4}</div>
              )}
              {!_.isUndefined(creditCardPayment.expirationYear) && !_.isUndefined(creditCardPayment.expirationMonth) && (
                <>
                  <div className="separator">-</div>
                  <div className="card-expiration">
                    {creditCardPayment.expirationMonth}/{creditCardPayment.expirationYear}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}
      {paypalPayment && (
        <div className="paypal">
          {_.has(paypalPayment, 'imageUrl') && (
            <div className="credit-card-icon">
              {!_.isNull(paypalPayment.imageUrl) && (
                <img src={paypalPayment.imageUrl} alt="paypal" />
              )}
            </div>
          )}
          <div className="paypal-description">
            Charged to
            {_.has(paypalPayment, 'payerFirstName') && _.has(paypalPayment, 'payerLastName') && !_.isNull(paypalPayment.payerFirstName) && !_.isNull(paypalPayment.payerLastName) && (
              <b>
                {` ${paypalPayment.payerFirstName} ${paypalPayment.payerLastName}`}
              </b>
            )}
            {!_.isNull(paypalPayment.payerEmail) && (
              <> ({paypalPayment.payerEmail})</>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

PaymentMethodDetails.propTypes = {
  creditCardPayment: PropTypes.shape({
    cardType: PropTypes.string.isRequired,
    last4: PropTypes.string.isRequired,
    expirationMonth: PropTypes.string,
    expirationYear: PropTypes.string,
    imageUrl: PropTypes.string
  }),
  paypalPayment: PropTypes.shape({
    imageUrl: PropTypes.string,
    payerEmail: PropTypes.string,
    payerFirstName: PropTypes.string,
    payerLastName: PropTypes.string
  })
}

export default PaymentMethodDetails
